








































































import gql from 'graphql-tag'
import { Component, Mixins } from 'vue-property-decorator'

import AppConfirmModal from '@/components/AppConfirmModal.vue'
import AppCoupon from '@/components/AppCoupon.vue'
import AppRouterLink from '@/components/AppRouterLink.vue'
import AppTitleBar from '@/components/AppTitleBar.vue'
import { Coupon } from '@/mixins'

@Component({
  components: {
    AppConfirmModal,
    AppCoupon,
    AppRouterLink,
    AppTitleBar
  },
  apollo: {
    user: {
      query: gql`query userAtProfileCoupons {
        user {
          id
          userCoupons {
            id
            usedAt
            expiredAt
            createdAt
            coupon {
              id
              name
              description
              type
              param1
              param2
              startedAt
              expiredAt
              createdAt
              isActive
              downloadsPerUser
              availableDaysAfterDownload
              applicableShoppingMallNames
              applyType
            }
          }
        }
      }`
    }
  }
})
export default class extends Mixins(Coupon) {
  code = ''
  popupUserCouponIndex = -1
  user: {
    userCoupons: {}[];
  } = {
    userCoupons: []
  }

  get isUiCouponNewEnabled () {
    return !!process.env.VUE_APP_UI_COUPON_NEW
  }

  get popupUserCoupon () {
    return this.user.userCoupons[this.popupUserCouponIndex]
  }

  routeTo ({ id, applicableShoppingMallNames }: { id: string; applicableShoppingMallNames: string }) {
    return applicableShoppingMallNames ? `/profile/coupons/${id}/items` : '/shopping'
  }

  async onClickRegisterCode () {
    await this.$apollo.mutate({
      mutation: gql`mutation downloadCouponByCode($code: String!) {
        downloadCouponByCode(code: $code) {
          id
        }
      }`,
      variables: {
        code: this.code
      }
    })
    await this.showToast('등록되었습니다')
    await this.$apollo.queries.user.refetch()
  }
}
